import { useState, useEffect } from 'react';

const STORAGE_KEY = 'anonymous_story_reads';
const MAX_ANONYMOUS_READS = 10;

export const useAnonymousLimits = () => {
    const [storiesRead, setStoriesRead] = useState<number>(0);
    const [hasReachedLimit, setHasReachedLimit] = useState<boolean>(false);

    useEffect(() => {
        // Load current count from localStorage
        const stored = localStorage.getItem(STORAGE_KEY);
        const count = stored ? parseInt(stored, 10) : 0;
        setStoriesRead(count);
        setHasReachedLimit(count >= MAX_ANONYMOUS_READS);
    }, []);

    const incrementStoryRead = () => {
        const newCount = storiesRead + 1;
        setStoriesRead(newCount);
        localStorage.setItem(STORAGE_KEY, newCount.toString());
        
        if (newCount >= MAX_ANONYMOUS_READS) {
            setHasReachedLimit(true);
        }
        
        return newCount;
    };

    const resetCount = () => {
        localStorage.removeItem(STORAGE_KEY);
        setStoriesRead(0);
        setHasReachedLimit(false);
    };

    const getRemainingReads = () => {
        return Math.max(0, MAX_ANONYMOUS_READS - storiesRead);
    };

    return {
        storiesRead,
        hasReachedLimit,
        incrementStoryRead,
        resetCount,
        getRemainingReads,
        maxReads: MAX_ANONYMOUS_READS
    };
};
